import React from 'react';

const { __, getLocaleData } = window.wp.i18n;

class NoJobs extends React.Component {
  render () {
    return (
      <div className="section__block col-8 section__noresults container">
        <h3 className="section__regular-title">
          { __('No results matching your search', 'macs-react-jobs') }
        </h3>
      </div>
    );
  }
}

export default NoJobs;
